var _rect, _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGoal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    transform: "translate(0 0.5)",
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.25977 11.52V16.49C4.25977 18.31 4.25977 18.31 5.97977 19.47L10.7098 22.2C11.4198 22.61 12.5798 22.61 13.2898 22.2L18.0198 19.47C19.7398 18.31 19.7398 18.31 19.7398 16.49V11.52C19.7398 9.7 19.7398 9.7 18.0198 8.54L13.2898 5.81C12.5798 5.4 11.4198 5.4 10.7098 5.81L5.97977 8.54C4.25977 9.7 4.25977 9.7 4.25977 11.52Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5 8.13V5.5C17.5 3.5 16.5 2.5 14.5 2.5H9.5C7.5 2.5 6.5 3.5 6.5 5.5V8.06",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6298 11.49L13.1998 12.38C13.2898 12.52 13.4898 12.66 13.6398 12.7L14.6598 12.96C15.2898 13.12 15.4598 13.66 15.0498 14.16L14.3798 14.97C14.2798 15.1 14.1998 15.33 14.2098 15.49L14.2698 16.54C14.3098 17.19 13.8498 17.52 13.2498 17.28L12.2698 16.89C12.1198 16.83 11.8698 16.83 11.7198 16.89L10.7398 17.28C10.1398 17.52 9.67978 17.18 9.71978 16.54L9.77978 15.49C9.78978 15.33 9.70978 15.09 9.60978 14.97L8.93978 14.16C8.52978 13.66 8.69978 13.12 9.32978 12.96L10.3498 12.7C10.5098 12.66 10.7098 12.51 10.7898 12.38L11.3598 11.49C11.7198 10.95 12.2798 10.95 12.6298 11.49Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoal);
export default __webpack_public_path__ + "static/media/goal.6141bc22a39b75ebeedb99455e75f952.svg";
export { ForwardRef as ReactComponent };